export default function createSelectReducer(TYPE) {
  const INIT_STATE = {
    data: new Map(),
  };
  return function selectReducer(state = INIT_STATE, action) {
    switch (action.type) {
      case `${TYPE}_SELECT_LINE`: {
        const data = action.data;

        const selectData = new Map(state.data);
        if (action.force_select) {
          selectData.clear();
          selectData.set(data.id, data);
          return {
            ...state,
            data: selectData,
          };
        }

        if (selectData.has(data.id)) {
          selectData.delete(data.id);
        } else {
          selectData.set(data.id, data);
        }

        return {
          ...state,
          data: selectData,
        };
      }

      case `${TYPE}_UPDATE_SELECT_LINE`: {
        const selectData = new Map(state.data);
        const controlRecord = action.data;

        if (selectData.has(action.key)) {
          const saleGroup = selectData.get(action.key)
          saleGroup.oms_control_records = saleGroup.oms_control_records.map((cr) => {
            if (cr.id === controlRecord.id) {
              return controlRecord;
            }
            return cr;
          });

          selectData.set(action.key, saleGroup);

          return {
            ...state,
            data: selectData,
          };
        }

        return state;
      }

      case `${TYPE}_UPDATE_SELECT_LINES`: {
        const { payload } = action;
        const selectData = new Map(state.data);

        payload.forEach(omcr => {
          const { sale_transaction_id } = omcr;
          const saleGroup = selectData.get(sale_transaction_id);

          if (!saleGroup) return;

          saleGroup.oms_control_records = saleGroup.oms_control_records.map((saleLineOmcr) => {
            if (saleLineOmcr.id === omcr.id) return { ...saleLineOmcr, ...omcr };
            return saleLineOmcr;
          });

          selectData.set(sale_transaction_id, saleGroup);
        });

        return {
          ...state,
          data: selectData,
        };
      }

      case `${TYPE}_SELECT_LINES`: {
        const list = action.data;

        if (action.is_checked) {
          list.forEach((data) => {
            if (action.force_select) {
              state.data.delete(data.id);
            }
            state.data.set(data.id, data);
          });
        } else {
          list.forEach((data) => state.data.delete(data.id));
        }

        return state;
      }

      case `${TYPE}_RESET_SELECT_LINES`: {
        return {
          data: new Map(),
        };
      }

      case `${TYPE}_SET_SELECT_LINE`: {
        const data = action.data;
        const selectData = new Map(state.data);
        selectData.set(data.id, data);

        return {
          ...state,
          data: selectData,
        };
      }

      case `${TYPE}_UPDATE_SELECT_GROUP_DELIVERY_ADDRESS`: {
        const { payload } = action;
        const { key, data } = payload;
        const { delivery_address, delivery_note } = data;
        const selectData = new Map(state.data);

        if (!selectData.has(key)) return state;

        const selectedSaleGroup = selectData.get(key);

        selectData.set(key, {
          ...selectedSaleGroup,
          delivery_address,
          delivery_note,
        });

        return {
          ...state,
          data: selectData,
        };
      }

      case `${TYPE}_UPDATE_SELECT_GROUP_SHIPPING_DETAILS`: {
        const { payload } = action;
        const { key, data } = payload;
        const selectData = new Map(state.data);

        if (!selectData.has(key)) return state;

        const selectedSaleGroup = selectData.get(key);

        selectData.set(key, {
          ...selectedSaleGroup,
          oms_control_records: selectedSaleGroup.oms_control_records.map(omcr => ({
            ...omcr,
            st_item_ship_line: {
              ...(omcr.st_item_ship_line || {}),
              ...(data || {}),
            },
          }))
        });

        return {
          ...state,
          data: selectData,
        };
      }

      default:
        return state;
    }
  };
}
